import { Injectable } from '@angular/core';
import { AuthData } from '@app/core/models/auth.model';
import { Observable, of } from 'rxjs';
import {
  Permission,
  UserPermission,
} from '../../models/access-control/user-permission.model';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private userPermission: UserPermission = undefined;

  get permissions(): UserPermission | undefined {
    return this.userPermission;
  }

  init(authData: AuthData): Observable<void> {
    this.userPermission = new UserPermission();

    // Set area permissions.
    this.userPermission.area = authData.permissions;
    this.userPermission.areaMap = this.getPermissionMap(authData.permissions);

    return of(void 0);
  }

  getAreaPermission(area: string, action: string): Permission {
    const key = `${area}::${action}`;
    return (
      this.userPermission.areaMap[key] ?? {
        area: '',
        action: '',
        value: '',
        accesslevel: 0,
      }
    );
  }

  private getPermissionMap(
    permission: Permission[]
  ): Record<string, Permission> {
    const map: Record<string, Permission> = {};

    permission.forEach((p) => (map[`${p.area}::${p.action}`] = p));

    return map;
  }
}
